<template>
  <form @submit.prevent="submit">
    <naj-dynamic-form
      :form-model="formModel"
      :form-fields="fields"
    ></naj-dynamic-form>
    <naj-button type="submit">
      submit
    </naj-button>
  </form>
</template>

<script>
export default {
  name: 'Demo',
  components: {},
  data() {
    return {
      formModel: { map: null },
      fields: [{
        name: 'name',
        label: 'الاسم',
        typeId: 1,
        columnSize: 6,
      }],
    };
  },
  mounted() {
  },
  methods: {
    submit() {
      this.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            // valid
          } else {
            // not valid
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.map-component {
  margin: 50px; // for demo only
}
</style>
